<template>
	<div>
		<b-breadcrumb>
			<b-breadcrumb-item text="Home" to="/"/>
			<b-breadcrumb-item text="Dashboard"/>
			<b-breadcrumb-item text="Custom" :active="true"/>
		</b-breadcrumb>
		<b-container ref="container" fluid style="background-color: #fff">
			<splitpanes class="default-theme" style="height: 750px">
				<pane size="20" min-size="10" max-size="50">
				</pane>
				<pane>
					<template v-for="chartConfig in chartConfigs">
						<b-col cols="6">
						<b-card :title="chartConfig.name" :visible=true>
							<b-card-text style="overflow:auto; height: 700px">
								<cpu-chart :config="chartConfig"/>
							</b-card-text>
						</b-card>
						</b-col>
					</template>
				</pane>
			</splitpanes>
		</b-container>
	</div>
</template>

<script>
import {HTTP} from '../../services/HttpService'
import {colorService} from '../../services/ColorService'
import CpuChart from '../../components/server-charts/CpuChart.vue'
import CollapsibleCard from '../../components/CollapsibleCard.vue'

export default {
  components: {
    CpuChart,
    CollapsibleCard
  },
  name: 'dashboard',
  data: () => ({
    servers: null,
    chartConfigs: []
  }),
  methods: {
    colorSeverity (color, value) {
      console.log(colorService.colorHexToRGBA(color, value / 100))
      return colorService.colorHexToRGBA(color, value / 100)
    },
    loadServers () {
      HTTP.get('servers', {
        params: {
          page: 0,
          rowsPerPage: 1000
        }
      })
      .then(response => {
        this.servers = response.data.list
        this.serversMap = []
        for (var i in this.servers) {
          var server = this.servers[i]
          server.visible = true
        }
      })
    },
    fullScreen () {
      this.$refs.container.webkitRequestFullscreen()
    }
  },
  created () {
    this.loadServers()
    this.chartConfigs.push({
      id: 1,
      name: 'CPU Trend',
      type: 'cpu',
      serverIds: ['652569b93f28567d407d480c']
    })
  },
  destroyed () {
    clearInterval(this.refreshInterval)
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// CustomDashboardPage.vue?5e1ed76a